import { Address } from './user';
import { FlightData } from './flight';
import { LoanSimulation } from './loan';
import { Payment } from './payment';
import { PersonalData } from './user';
import { SessionTime } from './sessionTime';

export interface Proposal {
  proposalId: string;
  expireTime: number;
  successfulRedirectUrl: string;
  failedRedirectUrl: string;
  operationId: string;
  status: string;
  personalData: PersonalData;
  address: Address;
  flightData: FlightData[];
  loanSimulation: LoanSimulation[];
  payments?: Payment[];
  sessionTime?: SessionTime;
}

export enum CheckProposalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
export interface CheckProposalResponse {
  status: CheckProposalStatus;
  proposalId: string;
}
